/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CloudVolumeMetrics } from '../models';
// @ts-ignore
import type { ClusterStorageSummary } from '../models';
// @ts-ignore
import type { NodeStorageMetrics } from '../models';
// @ts-ignore
import type { NodeStorageSummary } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * StorageMetricsAPIApi - axios parameter creator
 * @export
 */
export const StorageMetricsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns performance timeseries metrics for a specific cloud volume.
         * @summary Returns performance timeseries metrics for a specific cloud volume.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} nodeName Node name.
         * @param {string} volumeId Cloud provider volume ID.
         * @param {string} [startTime] Start of the time range (inclusive).
         * @param {string} [endTime] End of the time range (inclusive).
         * @param {string} [step] Bucket step. One of: \&quot;1m\&quot;, \&quot;5m\&quot;, \&quot;1h\&quot;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storageMetricsAPIGetCloudVolumeMetrics: async (organizationId: string, clusterId: string, nodeName: string, volumeId: string, startTime?: string, endTime?: string, step?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('storageMetricsAPIGetCloudVolumeMetrics', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('storageMetricsAPIGetCloudVolumeMetrics', 'clusterId', clusterId)
            // verify required parameter 'nodeName' is not null or undefined
            assertParamExists('storageMetricsAPIGetCloudVolumeMetrics', 'nodeName', nodeName)
            // verify required parameter 'volumeId' is not null or undefined
            assertParamExists('storageMetricsAPIGetCloudVolumeMetrics', 'volumeId', volumeId)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/nodes/{nodeName}/cloud-volumes/{volumeId}/metrics`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"nodeName"}}`, encodeURIComponent(String(nodeName)))
                .replace(`{${"volumeId"}}`, encodeURIComponent(String(volumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (step !== undefined) {
                localVarQueryParameter['step'] = step;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns cluster storage summary.
         * @summary Returns cluster storage summary.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storageMetricsAPIGetClusterStorageSummary: async (organizationId: string, clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('storageMetricsAPIGetClusterStorageSummary', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('storageMetricsAPIGetClusterStorageSummary', 'clusterId', clusterId)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/storage-summary`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns size and performance timeseries metrics for a storage (root or managed-ephemeral).
         * @summary Returns size and performance timeseries metrics for a storage.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} nodeName Node name.
         * @param {string} storageType Storage type. One of: \&quot;root\&quot;, \&quot;managed-ephemeral\&quot;.
         * @param {string} [startTime] Start of the time range (inclusive).
         * @param {string} [endTime] End of the time range (inclusive).
         * @param {string} [step] Bucket step. One of: \&quot;1m\&quot;, \&quot;5m\&quot;, \&quot;1h\&quot;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storageMetricsAPIGetNodeStorageMetrics: async (organizationId: string, clusterId: string, nodeName: string, storageType: string, startTime?: string, endTime?: string, step?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('storageMetricsAPIGetNodeStorageMetrics', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('storageMetricsAPIGetNodeStorageMetrics', 'clusterId', clusterId)
            // verify required parameter 'nodeName' is not null or undefined
            assertParamExists('storageMetricsAPIGetNodeStorageMetrics', 'nodeName', nodeName)
            // verify required parameter 'storageType' is not null or undefined
            assertParamExists('storageMetricsAPIGetNodeStorageMetrics', 'storageType', storageType)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/nodes/{nodeName}/storages/{storageType}/metrics`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"nodeName"}}`, encodeURIComponent(String(nodeName)))
                .replace(`{${"storageType"}}`, encodeURIComponent(String(storageType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (step !== undefined) {
                localVarQueryParameter['step'] = step;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns node storage summary including capabilities and storage layout.
         * @summary Returns node storage summary including capabilities and storage layout.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} nodeName Node name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storageMetricsAPIGetNodeStorageSummary: async (organizationId: string, clusterId: string, nodeName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('storageMetricsAPIGetNodeStorageSummary', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('storageMetricsAPIGetNodeStorageSummary', 'clusterId', clusterId)
            // verify required parameter 'nodeName' is not null or undefined
            assertParamExists('storageMetricsAPIGetNodeStorageSummary', 'nodeName', nodeName)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/nodes/{nodeName}/storage-summary`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"nodeName"}}`, encodeURIComponent(String(nodeName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StorageMetricsAPIApi - functional programming interface
 * @export
 */
export const StorageMetricsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StorageMetricsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns performance timeseries metrics for a specific cloud volume.
         * @summary Returns performance timeseries metrics for a specific cloud volume.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} nodeName Node name.
         * @param {string} volumeId Cloud provider volume ID.
         * @param {string} [startTime] Start of the time range (inclusive).
         * @param {string} [endTime] End of the time range (inclusive).
         * @param {string} [step] Bucket step. One of: \&quot;1m\&quot;, \&quot;5m\&quot;, \&quot;1h\&quot;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storageMetricsAPIGetCloudVolumeMetrics(organizationId: string, clusterId: string, nodeName: string, volumeId: string, startTime?: string, endTime?: string, step?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CloudVolumeMetrics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storageMetricsAPIGetCloudVolumeMetrics(organizationId, clusterId, nodeName, volumeId, startTime, endTime, step, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageMetricsAPIApi.storageMetricsAPIGetCloudVolumeMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns cluster storage summary.
         * @summary Returns cluster storage summary.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storageMetricsAPIGetClusterStorageSummary(organizationId: string, clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClusterStorageSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storageMetricsAPIGetClusterStorageSummary(organizationId, clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageMetricsAPIApi.storageMetricsAPIGetClusterStorageSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns size and performance timeseries metrics for a storage (root or managed-ephemeral).
         * @summary Returns size and performance timeseries metrics for a storage.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} nodeName Node name.
         * @param {string} storageType Storage type. One of: \&quot;root\&quot;, \&quot;managed-ephemeral\&quot;.
         * @param {string} [startTime] Start of the time range (inclusive).
         * @param {string} [endTime] End of the time range (inclusive).
         * @param {string} [step] Bucket step. One of: \&quot;1m\&quot;, \&quot;5m\&quot;, \&quot;1h\&quot;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storageMetricsAPIGetNodeStorageMetrics(organizationId: string, clusterId: string, nodeName: string, storageType: string, startTime?: string, endTime?: string, step?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeStorageMetrics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storageMetricsAPIGetNodeStorageMetrics(organizationId, clusterId, nodeName, storageType, startTime, endTime, step, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageMetricsAPIApi.storageMetricsAPIGetNodeStorageMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns node storage summary including capabilities and storage layout.
         * @summary Returns node storage summary including capabilities and storage layout.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} nodeName Node name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storageMetricsAPIGetNodeStorageSummary(organizationId: string, clusterId: string, nodeName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeStorageSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storageMetricsAPIGetNodeStorageSummary(organizationId, clusterId, nodeName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageMetricsAPIApi.storageMetricsAPIGetNodeStorageSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StorageMetricsAPIApi - factory interface
 * @export
 */
export const StorageMetricsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StorageMetricsAPIApiFp(configuration)
    return {
        /**
         * Returns performance timeseries metrics for a specific cloud volume.
         * @summary Returns performance timeseries metrics for a specific cloud volume.
         * @param {StorageMetricsAPIApiStorageMetricsAPIGetCloudVolumeMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storageMetricsAPIGetCloudVolumeMetrics(requestParameters: StorageMetricsAPIApiStorageMetricsAPIGetCloudVolumeMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CloudVolumeMetrics> {
            return localVarFp.storageMetricsAPIGetCloudVolumeMetrics(requestParameters.organizationId, requestParameters.clusterId, requestParameters.nodeName, requestParameters.volumeId, requestParameters.startTime, requestParameters.endTime, requestParameters.step, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns cluster storage summary.
         * @summary Returns cluster storage summary.
         * @param {StorageMetricsAPIApiStorageMetricsAPIGetClusterStorageSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storageMetricsAPIGetClusterStorageSummary(requestParameters: StorageMetricsAPIApiStorageMetricsAPIGetClusterStorageSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClusterStorageSummary> {
            return localVarFp.storageMetricsAPIGetClusterStorageSummary(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns size and performance timeseries metrics for a storage (root or managed-ephemeral).
         * @summary Returns size and performance timeseries metrics for a storage.
         * @param {StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storageMetricsAPIGetNodeStorageMetrics(requestParameters: StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<NodeStorageMetrics> {
            return localVarFp.storageMetricsAPIGetNodeStorageMetrics(requestParameters.organizationId, requestParameters.clusterId, requestParameters.nodeName, requestParameters.storageType, requestParameters.startTime, requestParameters.endTime, requestParameters.step, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns node storage summary including capabilities and storage layout.
         * @summary Returns node storage summary including capabilities and storage layout.
         * @param {StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storageMetricsAPIGetNodeStorageSummary(requestParameters: StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<NodeStorageSummary> {
            return localVarFp.storageMetricsAPIGetNodeStorageSummary(requestParameters.organizationId, requestParameters.clusterId, requestParameters.nodeName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for storageMetricsAPIGetCloudVolumeMetrics operation in StorageMetricsAPIApi.
 * @export
 * @interface StorageMetricsAPIApiStorageMetricsAPIGetCloudVolumeMetricsRequest
 */
export interface StorageMetricsAPIApiStorageMetricsAPIGetCloudVolumeMetricsRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof StorageMetricsAPIApiStorageMetricsAPIGetCloudVolumeMetrics
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof StorageMetricsAPIApiStorageMetricsAPIGetCloudVolumeMetrics
     */
    readonly clusterId: string

    /**
     * Node name.
     * @type {string}
     * @memberof StorageMetricsAPIApiStorageMetricsAPIGetCloudVolumeMetrics
     */
    readonly nodeName: string

    /**
     * Cloud provider volume ID.
     * @type {string}
     * @memberof StorageMetricsAPIApiStorageMetricsAPIGetCloudVolumeMetrics
     */
    readonly volumeId: string

    /**
     * Start of the time range (inclusive).
     * @type {string}
     * @memberof StorageMetricsAPIApiStorageMetricsAPIGetCloudVolumeMetrics
     */
    readonly startTime?: string

    /**
     * End of the time range (inclusive).
     * @type {string}
     * @memberof StorageMetricsAPIApiStorageMetricsAPIGetCloudVolumeMetrics
     */
    readonly endTime?: string

    /**
     * Bucket step. One of: \&quot;1m\&quot;, \&quot;5m\&quot;, \&quot;1h\&quot;.
     * @type {string}
     * @memberof StorageMetricsAPIApiStorageMetricsAPIGetCloudVolumeMetrics
     */
    readonly step?: string
}

/**
 * Request parameters for storageMetricsAPIGetClusterStorageSummary operation in StorageMetricsAPIApi.
 * @export
 * @interface StorageMetricsAPIApiStorageMetricsAPIGetClusterStorageSummaryRequest
 */
export interface StorageMetricsAPIApiStorageMetricsAPIGetClusterStorageSummaryRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof StorageMetricsAPIApiStorageMetricsAPIGetClusterStorageSummary
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof StorageMetricsAPIApiStorageMetricsAPIGetClusterStorageSummary
     */
    readonly clusterId: string
}

/**
 * Request parameters for storageMetricsAPIGetNodeStorageMetrics operation in StorageMetricsAPIApi.
 * @export
 * @interface StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageMetricsRequest
 */
export interface StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageMetricsRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageMetrics
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageMetrics
     */
    readonly clusterId: string

    /**
     * Node name.
     * @type {string}
     * @memberof StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageMetrics
     */
    readonly nodeName: string

    /**
     * Storage type. One of: \&quot;root\&quot;, \&quot;managed-ephemeral\&quot;.
     * @type {string}
     * @memberof StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageMetrics
     */
    readonly storageType: string

    /**
     * Start of the time range (inclusive).
     * @type {string}
     * @memberof StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageMetrics
     */
    readonly startTime?: string

    /**
     * End of the time range (inclusive).
     * @type {string}
     * @memberof StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageMetrics
     */
    readonly endTime?: string

    /**
     * Bucket step. One of: \&quot;1m\&quot;, \&quot;5m\&quot;, \&quot;1h\&quot;.
     * @type {string}
     * @memberof StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageMetrics
     */
    readonly step?: string
}

/**
 * Request parameters for storageMetricsAPIGetNodeStorageSummary operation in StorageMetricsAPIApi.
 * @export
 * @interface StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageSummaryRequest
 */
export interface StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageSummaryRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageSummary
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageSummary
     */
    readonly clusterId: string

    /**
     * Node name.
     * @type {string}
     * @memberof StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageSummary
     */
    readonly nodeName: string
}

/**
 * StorageMetricsAPIApi - object-oriented interface
 * @export
 * @class StorageMetricsAPIApi
 * @extends {BaseAPI}
 */
export class StorageMetricsAPIApi extends BaseAPI {
    /**
     * Returns performance timeseries metrics for a specific cloud volume.
     * @summary Returns performance timeseries metrics for a specific cloud volume.
     * @param {StorageMetricsAPIApiStorageMetricsAPIGetCloudVolumeMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorageMetricsAPIApi
     */
    public storageMetricsAPIGetCloudVolumeMetrics(requestParameters: StorageMetricsAPIApiStorageMetricsAPIGetCloudVolumeMetricsRequest, options?: RawAxiosRequestConfig) {
        return StorageMetricsAPIApiFp(this.configuration).storageMetricsAPIGetCloudVolumeMetrics(requestParameters.organizationId, requestParameters.clusterId, requestParameters.nodeName, requestParameters.volumeId, requestParameters.startTime, requestParameters.endTime, requestParameters.step, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns cluster storage summary.
     * @summary Returns cluster storage summary.
     * @param {StorageMetricsAPIApiStorageMetricsAPIGetClusterStorageSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorageMetricsAPIApi
     */
    public storageMetricsAPIGetClusterStorageSummary(requestParameters: StorageMetricsAPIApiStorageMetricsAPIGetClusterStorageSummaryRequest, options?: RawAxiosRequestConfig) {
        return StorageMetricsAPIApiFp(this.configuration).storageMetricsAPIGetClusterStorageSummary(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns size and performance timeseries metrics for a storage (root or managed-ephemeral).
     * @summary Returns size and performance timeseries metrics for a storage.
     * @param {StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorageMetricsAPIApi
     */
    public storageMetricsAPIGetNodeStorageMetrics(requestParameters: StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageMetricsRequest, options?: RawAxiosRequestConfig) {
        return StorageMetricsAPIApiFp(this.configuration).storageMetricsAPIGetNodeStorageMetrics(requestParameters.organizationId, requestParameters.clusterId, requestParameters.nodeName, requestParameters.storageType, requestParameters.startTime, requestParameters.endTime, requestParameters.step, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns node storage summary including capabilities and storage layout.
     * @summary Returns node storage summary including capabilities and storage layout.
     * @param {StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorageMetricsAPIApi
     */
    public storageMetricsAPIGetNodeStorageSummary(requestParameters: StorageMetricsAPIApiStorageMetricsAPIGetNodeStorageSummaryRequest, options?: RawAxiosRequestConfig) {
        return StorageMetricsAPIApiFp(this.configuration).storageMetricsAPIGetNodeStorageSummary(requestParameters.organizationId, requestParameters.clusterId, requestParameters.nodeName, options).then((request) => request(this.axios, this.basePath));
    }
}

